import getProfileStore from '../store/profileStore';
import type { AccountSource } from 'owa-graph-schema';
import { getAccountSourceById } from './getAccountSourceById';

export function getSelectedAccount(): AccountSource | undefined {
    return getAccountSourceById(getProfileStore().selectedAccountSourceId);
}
